<body class="authentication-bg">
    <div class="position-absolute start-0 end-0 start-0 bottom-0 w-100 h-100">
        <svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 800 800'>
            <g fill-opacity='0.22'>
                <circle style="fill: rgba(var(--ct-primary-rgb), 0.1);" cx='400' cy='400' r='600' />
                <circle style="fill: rgba(var(--ct-primary-rgb), 0.2);" cx='400' cy='400' r='500' />
                <circle style="fill: rgba(var(--ct-primary-rgb), 0.3);" cx='400' cy='400' r='300' />
                <circle style="fill: rgba(var(--ct-primary-rgb), 0.4);" cx='400' cy='400' r='200' />
                <circle style="fill: rgba(var(--ct-primary-rgb), 0.5);" cx='400' cy='400' r='100' />
            </g>
        </svg>
    </div>

    <div class="account-pages pt-2 pt-sm-5 pb-4 pb-sm-5 position-relative">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xxl-4 col-lg-5">
                    <div class="card">
                        <!-- Logo -->
                        <div class="card-header py-4 text-center bg-primary">
                            <a href="index.html">
                                <span><img src="assets/images/logo.png" alt="logo" height="44"></span>
                            </a>
                        </div>

                        <div class="card-body p-4">
                            <form [formGroup]="form">
                                <div class="mb-2">
                                    <label for="email" class="form-label">Enter your email address</label>
                                    <input type="text" id="email" formControlName="email" class="form-control" placeholder="Email">
                                </div>
                                @if(error) {
                                    <div class="mb-2">
                                        <span class="text-danger">{{error}}</span>
                                    </div>
                                }
                                <div class="text-center">
                                    @if(loading) {
                                        <button type="button" (click)="forgottenPassword()" class="btn btn-primary mt-3" disabled>
                                            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            Send reset email</button>
                                    } @else {
                                        <button type="button" (click)="forgottenPassword()" class="btn btn-primary mt-3">Send reset email</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                    <!-- end card -->
                </div> <!-- end col -->
                <div class="row mt-3">
                    <div class="col-12 text-center">
                        <p class="text-muted">Back to<a href="login" class="text-muted ms-1"><b>login</b></a></p>
                    </div> <!-- end col -->
                </div>
            </div>
            <!-- end row -->
        </div>
        <!-- end container -->
    </div>
    <!-- end page -->

    <footer class="footer footer-alt">
        © ZenVoice
    </footer>
</body>